import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class AboutSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      type: 'slide',
      autoWidth: true,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 900,
      arrows: false,
      pagination: false,
      gap: `min(${16 / 16}rem, ${16 / 360 * 100}vw)`,
      padding: { right: `min(${16 / 16}rem, ${16 / 360 * 100}vw)` },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          // type: 'loop',
          destroy: true
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default AboutSlides